const LS_COMPARE_VERSIONS = "soil_sight_version_compare_selection";

export const readCompareVersions = (): { baseline: string | null; candidate: string | null } => {
  try {
    const raw = localStorage.getItem(LS_COMPARE_VERSIONS);
    if (!raw) return { baseline: null, candidate: null };
    const parsed = JSON.parse(raw) as { baseline?: string | null; candidate?: string | null };
    return { baseline: parsed.baseline ?? null, candidate: parsed.candidate ?? null };
  } catch {
    return { baseline: null, candidate: null };
  }
};

export const writeCompareVersions = (baseline: string | null, candidate: string | null) => {
  try {
    localStorage.setItem(LS_COMPARE_VERSIONS, JSON.stringify({ baseline, candidate }));
  } catch {
    // ignore
  }
};

const LS_SINGLE_VERSION_SELECTION = "soil_sight_single_version_selection";

export const readSingleVersionSelection = (): string | null => {
  try {
    return localStorage.getItem(LS_SINGLE_VERSION_SELECTION);
  } catch {
    return null;
  }
};

export const writeSingleVersionSelection = (version: string | null) => {
  try {
    if (version) localStorage.setItem(LS_SINGLE_VERSION_SELECTION, version);
    else localStorage.removeItem(LS_SINGLE_VERSION_SELECTION);
  } catch {
    // ignore
  }
};
